import React, { Component, Fragment } from 'react';
import Chip from '@mui/material/Chip';
import CloseIcon from '@mui/icons-material/Close';
import VisibilityIcon from '@mui/icons-material/Visibility';


 
class ShowTextDetail extends Component {

    constructor(props) {
        super(props);
    
        this.state = {
          showtextinfo: false
        }

      }

      handleopenclosetext= (e) => {
        this.setState(prevState => ({
            showtextinfo: !prevState.showtextinfo
        }));
      }  

    render () {  

        const textdata = this.props.textdata
        
        return (
            <Fragment>
                {this.state.showtextinfo &&
                <Fragment>
                    <p className="logtext">{textdata}</p>
                    <hr />
                    <Chip 
                        label="Informationen ausblenden"
                        onClick={this.handleopenclosetext}
                        variant="outlined"
                        icon={<CloseIcon />} 
                    />  
                </Fragment>
                }
               
                {!this.state.showtextinfo && textdata !== null &&
                <Fragment>
                <hr />
                <Chip 
                label="Informationen ansehen"
                onClick={this.handleopenclosetext}
                variant="outlined"
                icon={<VisibilityIcon />}   
                /> 
               </Fragment>    
                }
            </Fragment>
          
        )
    }
}


export default ShowTextDetail;